<template>
    <div class="page-custom-register" >
        <div  >
            <h4 v-b-toggle.patient-collapse class="cursor-pointer" >ข้อมูลผู้ป่วย <v-icon name="arrow-down-circle" class="icon-custom1" ></v-icon></h4>
            <b-collapse id="patient-collapse" visible >
                <b-row>
                    <b-col sm="9"> 
    
                    </b-col>
                    <b-col sm="3">
                        <b-img v-bind="mainProps" rounded alt="Rounded image" style="margin-bottom:10px;"></b-img>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="HN" label-for="">
                            <!-- Using components -->
                            <b-input-group  >
                                <b-form-input size="sm" ></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="info" size="sm" ><v-icon name="search" class="icon-custom2" ></v-icon></b-button>
                                    <b-button variant="info" size="sm" ><v-icon name="search" class="icon-custom2" ></v-icon></b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>  
                    <b-col sm="6">
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="คำนำหน้าชื่อ" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">นาย</option>
                                <option value="a">นาง</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ชื่อ" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="นามสกุล" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ชื่อกลาง" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="เพศ" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">ชาย</option>
                                <option value="a">หญิง</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="วันเกิด" label-for="">
                            <b-form-input type="date" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="คำนวนอายุ" label-for="">
                            <b-alert variant="warning" class="padding-2px" show>0 ปี 0 เดือน 0 วัน</b-alert>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="วันเกิดจริง" label-for="">
                            <b-form-checkbox
                                id="checkbox-1"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                size="sm"
                                >
                                เป็นวันเกิดจริง
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    
                </b-row>
                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="ภาษา" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">ไทย</option>
                                <option value="a">อังกฤษ</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="สถานภาพ" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label-cols="3" label-cols-lg="2" label-size="sm" label="อาชีพ" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="เชื้อชาติ" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="สัญชาติ" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ศาสนา" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ชื่อเล่น" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="บัตรประชาชน" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="2">
                        <b-form-group label-cols="3" label-cols-lg="5" label-size="sm" label="หมู่เลือด" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="2">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="RH" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="5">
                        <b-form-group label-cols="3" label-cols-lg="2" label-size="sm" label="แพ้ยา" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-collapse>
        </div>
        <hr style="border-top: 1px solid rgba(221, 137, 74,1)" >
        
        <div  >
            <h4 v-b-toggle.pttype-collapse class="cursor-pointer" >สิทธิการรักษา <v-icon name="arrow-down-circle" class="icon-custom1" ></v-icon></h4>
            <b-collapse id="pttype-collapse" >
                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="6" label-size="sm" label="เลขสิทธิ" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="5">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ชื่อสิทธิ" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="เลขที่บัตร" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="6" label-size="sm" label="เริ่มใช้" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">ชาย</option>
                                <option value="a">หญิง</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="6" label-size="sm" label="หมดอายุ" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">ชาย</option>
                                <option value="a">หญิง</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="6">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="สถานพยาบาลหลัก" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">ไทย</option>
                                <option value="a">อังกฤษ</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="สถานพยาบาลรอง" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-collapse>
        </div>

        <hr style="border-top: 1px solid rgba(221, 137, 74,1)" >

        <div  >

            <h4 v-b-toggle.lacation-collapse class="cursor-pointer" >ข้อมูลที่อยู่ปัจจุบัน <v-icon name="arrow-down-circle" class="icon-custom1" ></v-icon></h4>

            <b-collapse id="lacation-collapse" >
                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="บ้านเลขที่" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">นาย</option>
                                <option value="a">นาง</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="หมู่" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ตรอก/ซอบ/ถนน" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="จังหวัด" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">ชาย</option>
                                <option value="a">หญิง</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="อำเภอ" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ตำบล" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ประเทศ" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
                </b-row>

                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="รหัสไปรษณีย์" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="อยู่ในเขต" label-for="">
                            <b-form-checkbox
                                id="checkbox-2"
                                name="checkbox-2"
                                value="accepted"
                                unchecked-value="not_accepted"
                                size="sm"
                                >
                                อยู่ในเขตรับผิดชอบ
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ใน CUPS" label-for="">
                            <b-form-checkbox
                                id="checkbox-3"
                                name="checkbox-3"
                                value="accepted"
                                unchecked-value="not_accepted"
                                size="sm"
                                >
                                อยู่ในเขตรับผิดชอบ CUPS
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="เบอร์โทร" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="สังกัดหลัก" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">ไทย</option>
                                <option value="a">อังกฤษ</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="สังกัดรอง" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="เลขที่ ขรก." label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="เลขที่ กบก." label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="Passport" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">นาย</option>
                                <option value="a">นาง</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="5">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ข้อมูลนายจ้าง" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">นาย</option>
                                <option value="a">นาง</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ประเภทนายจ้าง" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
                </b-row>

                <b-row>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="หน่วยขึ้นทะเบียน" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="CID นายจ้าง" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="Lock" label-for="">
                            <b-form-checkbox
                                id="checkbox-l"
                                name="checkbox-l"
                                value="accepted"
                                unchecked-value="not_accepted"
                                size="sm"
                                >
                                Lock ข้อมูลที่อยู่
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-collapse>
            
        </div>

        <hr style="border-top: 1px solid rgba(221, 137, 74,1)" >

        <div  >
            <h4 v-b-toggle.contact-collapse class="cursor-pointer" >ข้อมูลติดต่อ <v-icon name="arrow-down-circle" class="icon-custom1" ></v-icon></h4>

            <b-collapse id="contact-collapse" >
                <b-row>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ชื่อผู้ติดต่อ" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="HN มารดา" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12">
                        <b-form-group label-cols="3" label-cols-lg="1" label-size="sm" label="ที่อยู่ผู้ติดต่อ" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
                </b-row> 

                <b-row>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ความสัมพันธ์" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="เบอร์โทร" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ชื่อบิดา" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="นามสกุล" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="2" label-size="sm" label="เบอร์โทร" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ชื่อมารดา" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="นามสกุล" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="2" label-size="sm" label="เบอร์โทร" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="ชื่อคู่สมรส" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="3" label-size="sm" label="นามสกุล" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group label-cols="3" label-cols-lg="2" label-size="sm" label="เบอร์โทร" label-for="">
                            <b-form-input id="" size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="6">
                        <b-form-group label-cols="3" label-cols-lg="2" label-size="sm" label="Email" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label-cols="3" label-cols-lg="2" label-size="sm" label="ที่ทำงาน" label-for="">
                            <b-form-input type="text" size="sm" ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12">
                        <b-form-group label-cols="3" label-cols-lg="1" label-size="sm" label="หมายเหตุ" label-for="">
                            <b-form-select size="sm" >
                                <option :value="null">นาย</option>
                                <option value="a">นาง</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-collapse>
        </div>

    </div>
</template>

<script>

import { Component, Vue } from 'vue-property-decorator'
import { WebCam  } from 'vue-web-cam'
import feather from 'vue-icon'

Vue.use(feather, 'v-icon')
Vue.use(WebCam)

@Component({
    components: {
        // 'vue-web-cam' : WebCam 
    },
    data() {
        return {
            mainProps: { blank: true, blankColor: '#777', width: 100, height: 120, class: 'm1' },
            baseClass: 'v-icon'
        }
    }
})

export default class PatientRegister extends Vue {}

</script>


<style lang="scss">

.icon-custom1 {
    width: 24px;
}

.icon-custom2 {
    width: 14px;
}

.bd-group-custom1 {
    padding: 1.5rem;
    margin-right: 0;
    margin-left: 0;
    border-width: .5rem;
    padding: 1rem;
    margin: 1rem -15px 0;
    border: solid #f8f9fa;
    // border-width: .2rem 0 0;
    max-width: 1200px;
    margin: auto;
    text-align: left;
    margin-top: 20px !important;
    border-color: #41B883 !important;
    border: 1px solid transparent;
    border-radius: .25rem;
}

.bd-group-custom2 {
    padding: 1.5rem;
    margin-right: 0;
    margin-left: 0;
    border-width: .5rem;
    padding: 1rem;
    margin: 1rem -15px 0;
    border: solid #f8f9fa;
    // border-width: .2rem 0 0;
    max-width: 1200px;
    margin: auto;
    text-align: left;
    margin-top: 20px !important;
    border-color: #17A2B8 !important;
    border: 1px solid transparent;
    border-radius: .25rem;
}

.bd-group-custom3 {
    padding: 1.5rem;
    margin-right: 0;
    margin-left: 0;
    border-width: .5rem;
    padding: 1rem;
    margin: 1rem -15px 0;
    border: solid #f8f9fa;
    // border-width: .2rem 0 0;
    max-width: 1200px;
    margin: auto;
    text-align: left;
    margin-top: 20px !important;
    border-color: #FFF3A0 !important;
    border: 1px solid transparent;
    border-radius: .25rem;
}

.padding-2px {
    padding: 2px !important;
}

</style>
